import { Skeleton, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Layout from 'components/Layout';
import BackButton from 'components/Layout/Header/BackButton';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

function AuthWrapper({ subTitle, action, alert, loading, children, ...props }) {
  const isMobile = useIsMobile();

  return (
    <Layout
      footer={null}
      header={!isMobile && (
        <Layout.Header
          visibleElements={[
            Layout.Header.Elements.LOGO,
          ]}
        />
      )}
    >
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Box
          sx={(theme) => ({
            width: { xs: '100%', sm: 392 },
            height: { xs: '100vh', sm: 'fit-content' },
            border: { sm: `1px solid ${theme.palette.border.default}` },
            borderRadius: 2,
          })}
        >

          <Stack
            direction="row"
            alignItems="center"
            sx={(theme) => ({
              borderBottom: { xs: `1px solid ${theme.palette.border.default}`, sm: 0 },
              px: 2,
              py: 1.5,
            })}
          >
            <BackButton sx={{ pl: '0 !important' }}/>
            <Typography variant="title-md">Login / Signup</Typography>
          </Stack>

          <Stack sx={{ mt: { xs: 2, md: 0 }, px: 2 }}>{alert}</Stack>
          <Stack gap={3} alignItems="start" justifyContent={{ xs: 'start', sm: 'center' }} pt={1.5} pb={3} px={2}>
            {loading && <Skeleton width="100%" height="50px"/>}
            {!loading && (
              <>
                <Typography variant="body-md">
                  {subTitle}
                </Typography>

                {children}
              </>)}
          </Stack>

          <Stack
            sx={(theme) => ({
              p: 2,
              position: { xs: 'fixed', sm: 'static' },
              bottom: { xs: 0, sm: 'auto' },
              left: { xs: 0, sm: 'auto' },
              right: { xs: 0, sm: 'auto' },
              borderTop: { xs: `1px solid ${theme.palette.border.default}`, sm: 0 },
              zIndex: 1000,
            })}
          >
            {action}
          </Stack>

        </Box>
      </Box>
    </Layout>

  );
}

export default AuthWrapper;
